// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Icon from '@mui/material/Icon';

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DataTable from 'components/Tables/DataTable';
import MDPagination from 'components/MDPagination';

import Wizard from 'pantallas/Comprobantes/components/wizard/index';
import { CSVLink } from 'react-csv';

// Data
import { useEffect, useState, useCallback, useRef } from 'react';
import SplitButton from './Data/acciones';
import { getEmpresaInfoById } from 'actions/MiCuenta/miCuenta';
import {
	iMiEmpresaInfoToPDF,
	initMiEmpresaFormulario,
} from 'actions/MiCuenta/miCuentaTypes';
import { useSelector, useDispatch } from 'react-redux';
import { RootStore } from 'store/Store';
import moment from 'moment';
import ProgressBar from './components/ProgressBar/ProgressBar';
import { Dispatch } from 'redux';
import { axiosClient, getToken } from 'Config/axiosConfig';
import {
	LoadingDispatchTypes,
	LOADING_END,
	START_LOADING,
} from 'actions/Loading/loadingTypes';
import PXLoader from 'components/PXLoader/PXLoader';
import { numeroAMoneda } from 'helpers/aMoneda';
// import { ToastContainer } from 'react-toastify';
import EstatusPagoPagado from './components/EstatusPago/EstatusPagoPagado';
import EstatusPagoNoPagado from './components/EstatusPago/EstatusPagoNoPagado';

interface ComprobantesProps {
  // Letra de tipo de CFDI (I, E, T, N, P)
  tipoCfdiFilter?: string;
}

function Comprobantes({ tipoCfdiFilter }: ComprobantesProps): JSX.Element {
	const { empresa_id } = useSelector((state: RootStore) => state.auth);
	const { loading } = useSelector((state: RootStore) => state.loading);
	const dispatch = useDispatch();

	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = (event: object, reason: string) => {
		if (reason && reason == 'backdropClick') return;
		setOpen(false);
		setComprobanteToUpdate(null);
	};

	//useState que guarda la Data obtenida del servidor

	const [comprobantesListData, setComprobantesListData] = useState([]);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(10);
	const [total, setTotal] = useState(0);
	const [search, setSearch] = useState('');
	const [exportRows, setExportRows] = useState<any[]>([]);
	const csvRef = useRef<any>(null);
	const [exportOpen, setExportOpen] = useState(false);
	const [exporting, setExporting] = useState(false);

	const buildCsvRows = (items: any[]) =>
		items.map((d: any) => {
			if (d.estatus_comprobante_id === 1) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					Fecha: d.fecha,
					Subtotal: d.subtotal,
					IVA: d.iva,
					Total: d.total,
					Estatus: 'Cancelado',
				};
			}
			if (d.estatus_comprobante_id === 2) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					Fecha: d.fecha,
					Subtotal: d.subtotal,
					IVA: d.iva,
					Total: d.total,
					Estatus: 'Creado',
				};
			}
			if (d.estatus_comprobante_id === 3) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					Fecha: d.fecha,
					Subtotal: d.subtotal,
					IVA: d.iva,
					Total: d.total,
					Estatus: 'Timbrado',
				};
			}
			if (d.estatus_comprobante_id === 4) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					Fecha: d.fecha,
					Subtotal: d.subtotal,
					IVA: d.iva,
					Total: d.total,
					Estatus: 'Timbrado & Enviado',
				};
			}
      return {
        serie: d.serie,
        Folio: d.folio,
        Uuid: d.uuid,
        Cliente: d.nombre,
        Fecha: d.fecha,
        Subtotal: d.subtotal,
        IVA: d.iva,
        Total: d.total,
        Estatus: d.estatus_comprobante_id,
      };
    });

	const openExportModal = () => setExportOpen(true);
	const closeExportModal = () => { if (!exporting) setExportOpen(false); };

	const exportCurrentPage = () => {
		setExportRows(buildCsvRows(comprobantesListData));
		setTimeout(() => csvRef.current?.link?.click(), 0);
		setExportOpen(false);
	};

	const exportAllPages = async () => {
		try {
			setExporting(true);
			const all: any[] = [];
			let p = 1;
			const size = 200;
			for (;;) {
				const resp = await axiosClient.get(`/comprobantes`, {
					params: { page: p, limit: size, q: search },
				});
				const payload = resp.data;
				const pageData = Array.isArray(payload) ? payload : (payload?.data || []);
				all.push(...pageData);
				if (Array.isArray(payload)) break;
				const totalPages = payload?.meta?.totalPages || 1;
				if (p >= totalPages) break;
				p += 1;
			}
			setExportRows(buildCsvRows(all));
			setTimeout(() => csvRef.current?.link?.click(), 0);
		} catch (e) {
			console.error('Error al exportar CSV', e);
		} finally {
			setExporting(false);
			setExportOpen(false);
		}
	};
	const [comprobanteToUpdate, setComprobanteToUpdate] = useState();
	const [miEmpresa, setMiEmpresa] = useState<iMiEmpresaInfoToPDF>(
		initMiEmpresaFormulario
	);

	//GetEmpresaInfoById
	useEffect(() => {
		if (empresa_id) {
			const dataEmpresa = getEmpresaInfoById(empresa_id);
			dataEmpresa
				.then((respuesta) => {
					if (respuesta.status === 200) {
						setMiEmpresa(respuesta.data);
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
	}, [empresa_id]);

	const isMyDataValid = () => {
    // Solo validar campos requeridos por SAT para la emisión del CFDI del emisor
    // nombre (razón social), RFC, régimen fiscal y código postal
    if (!miEmpresa.nombre) return false;
    if (!miEmpresa.rfc) return false;
    if (!miEmpresa.regimen_fiscal) return false;
    if (!miEmpresa.codigo_postal) return false;

    return true;
    };

  const tipoComprobante = (tipoSerieId: number): string => {
    if (tipoSerieId === 1) {
      return 'Factura';
    } else if (tipoSerieId === 2) {
      return 'Recibo de Honorarios';
    }
  };

  // Clase CFDI (vista): si estamos en la pestaña de Egresos,
  // siempre mostrar "Egreso" aunque el CFDI sea tipo I en el SAT.
  // En Ingresos y vistas generales se muestra según la letra real.
  const claseCfdi = (letra: string | undefined): string => {
    if (tipoCfdiFilter?.toUpperCase() === 'E') {
      return 'Egreso';
    }
    switch ((letra || '').toUpperCase()) {
      case 'I': return 'Ingreso';
      case 'E': return 'Egreso';
      case 'T': return 'Traslado';
      case 'N': return 'Nómina';
      case 'P': return 'Pago';
      default: return '';
    }
  };

  //Estuctura de datos para tabla (el filtrado ingresos/egresos se hace en backend)
  const filteredData = comprobantesListData;

  const datosTabla = {
    columns: [
      { Header: 'UuId', accessor: 'UUID', width: '80px' },
      { Header: 'Serie', accessor: 'Serie', align: 'center' },
      { Header: 'Folio', accessor: 'Folio', width: '80px' },
      { Header: 'Emisor', accessor: 'Emisor', width: '260px' },
      { Header: 'Receptor', accessor: 'Receptor', width: '260px' },
      { Header: 'Fecha', accessor: 'Fecha' },
      { Header: 'Tipo', accessor: 'Tipo' },
      { Header: 'Subtotal', accessor: 'Subtotal' },
      { Header: 'I.V.A', accessor: 'IVA' },
      { Header: 'Total', accessor: 'Total' },
      { Header: 'Pagado', accessor: 'Pagado' },
      { Header: 'Estatus', accessor: 'Estatus' },
      { Header: 'Acciones', accessor: 'Acciones' },
    ],
    rows: filteredData
      .map((item) => {
        // Emisor: siempre el emisor del CFDI (si no viene, usamos la empresa en sesión).
        const emisorNombre =
          (item.emisor_nombre && String(item.emisor_nombre).trim().length > 0)
            ? item.emisor_nombre
            : (miEmpresa?.nombre || '');
        // Receptor: siempre la contraparte que viene almacenada en el comprobante.
        const receptorNombre = item.nombre || '';
        return {
          UUID: item.uuid ? item.uuid : '',
          Serie: item.serie,
          Folio: item.folio,
          Emisor: emisorNombre,
          Receptor: receptorNombre,
          Fecha: moment(item.fecha).format('DD-MM-YYYY'),
          Tipo: tipoComprobante(item.tipo_comprobante_id),
          Subtotal: numeroAMoneda(item.subtotal),
          IVA: numeroAMoneda(item.iva),
          Total: numeroAMoneda(item.total),
					Pagado: item.pagado ? <EstatusPagoPagado /> : <EstatusPagoNoPagado />,
					Estatus: (
						<>
							<ProgressBar progressId={item.estatus_comprobante_id} />
						</>
					),
					Acciones: (
						<>
							<SplitButton
								item={item}
								handleOpen={handleOpen}
								setComprobanteToUpdate={setComprobanteToUpdate}
								setComprobantesListData={setComprobantesListData}
								isMyDataValid={isMyDataValid}
							/>
						</>
          ),
        };
      }),
  };

  // Obtener Comprobantes paginados (filtrando opcionalmente ingresos/egresos en backend)
  const fetchComprobantes = useCallback(() => {
    return async (dispatch: Dispatch<LoadingDispatchTypes>) => {
      await getToken();
      dispatch({ type: START_LOADING });
      const params: any = { page, limit, q: search };
      if (tipoCfdiFilter?.toUpperCase() === 'E') {
        params.direccion = 'egresos';
      } else if (tipoCfdiFilter?.toUpperCase() === 'I') {
        params.direccion = 'ingresos';
      }
      axiosClient
        .get(`/comprobantes`, { params })
        .then((respuesta) => {
          const payload = respuesta.data;
          if (Array.isArray(payload)) {
            // Soporte legado (sin paginación)
            setComprobantesListData(payload);
            setTotal(payload.length);
          } else {
            setComprobantesListData(payload.data || []);
            setTotal(payload?.meta?.total || 0);
          }
          dispatch({ type: LOADING_END });
        })
        .catch((error) => {
          if (error?.response?.status === 500) {
            console.log('error500', error.response.data);
          } else if (error?.response?.status === 400) {
            console.log('error400', error.response.data);
          } else if (error?.response?.status === 403) {
            console.log('error403', error.response.data);
          } else {
            console.log(error?.response?.data || error?.message);
          }
          setComprobantesListData([]);
          dispatch({ type: LOADING_END });
        });
    };
  }, [page, limit, search, tipoCfdiFilter]);

  useEffect(() => {
    dispatch<any>(fetchComprobantes());
  }, [fetchComprobantes, dispatch]);

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Card>
					<MDBox p={3} lineHeight={1}>
            <MDTypography variant='h5' fontWeight='medium' color='primary'>
              {tipoCfdiFilter?.toUpperCase() === 'E'
                ? 'Comprobantes - Egresos'
                : 'Comprobantes - Ingresos'}
            </MDTypography>
						<Grid
							container
							direction='row'
							justifyContent='flex-end'
							alignItems='flex-end'
						>
              <MDButton size='small' color='primary' onClick={handleOpen}>
                + Agregar
              </MDButton>
              <MDButton size='small' sx={{ marginLeft: '5px', border: '1px solid' }} onClick={openExportModal}>
                + Exportar CSV
              </MDButton>
              {/* Link oculto para descarga de CSV */}
              <CSVLink data={exportRows} filename='Comprobantes.csv' ref={csvRef} style={{ display: 'none' }} />
						</Grid>
					</MDBox>
					<MDBox display={'flex'} justifyContent={'center'}>
						<MDBox style={{ width: '98%' }}>
							<DataTable table={datosTabla} canSearch isSorted={false} entriesPerPage={false} showTotalEntries={false} onServerSearch={(val: string) => { setPage(1); setSearch(val); }} />
							<MDBox display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={2}>
								<MDTypography variant='button' color='secondary' fontWeight='regular'>
									Mostrando {comprobantesListData.length} de {total} registros
								</MDTypography>
								<MDPagination>
									{page > 1 && (
										<MDPagination item onClick={() => setPage(1)}>
											<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>chevron_left</Icon>
											<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>chevron_left</Icon>
										</MDPagination>
									)}
									{page > 1 && (
										<MDPagination item onClick={() => setPage(page - 1)}>
											<Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
										</MDPagination>
									)}
									<MDTypography variant='caption' color='secondary' sx={{ mx: 2 }}>
										Página {page} de {Math.max(Math.ceil(total / limit), 1)}
									</MDTypography>
									{page < Math.max(Math.ceil(total / limit), 1) && (
										<MDPagination item onClick={() => setPage(page + 1)}>
											<Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
										</MDPagination>
									)}
									{page < Math.max(Math.ceil(total / limit), 1) && (
										<MDPagination item onClick={() => setPage(Math.max(Math.ceil(total / limit), 1))}>
											<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>chevron_right</Icon>
											<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>chevron_right</Icon>
										</MDPagination>
									)}
								</MDPagination>
							</MDBox>
						</MDBox>
					</MDBox>
					{loading && (
						<>
							<MDBox m={4}>
								<PXLoader />
							</MDBox>
						</>
					)}
				</Card>
			</MDBox>

			<Modal
				open={exportOpen}
				disableScrollLock={true}
				onClose={closeExportModal}
				aria-labelledby='export-modal-title'
				aria-describedby='export-modal-description'
			>
				<MDBox sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 420, maxWidth: '95vw', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, p: 3 }}>
					<MDTypography variant='h6' id='export-modal-title' mb={1}>Exportar CSV</MDTypography>
					<MDTypography variant='button' color='secondary' id='export-modal-description'>
						Elige qué exportar. Filtro actual: {search ? `'${search}'` : 'ninguno'}
					</MDTypography>
					<MDBox mt={3} display='flex' gap={1} justifyContent='flex-end'>
						<MDButton variant='outlined' color='secondary' disabled={exporting} onClick={exportCurrentPage}>
							Descargar página actual
						</MDButton>
						<MDButton variant='gradient' color='primary' disabled={exporting} onClick={exportAllPages}>
							{exporting ? 'Preparando…' : 'Descargar todas las páginas'}
						</MDButton>
					</MDBox>
				</MDBox>
			</Modal>

			<Modal
				open={open}
				disableScrollLock={true}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'
			>
				<MDBox sx={style}>
					{
						<Wizard
							comprobanteToUpdate={comprobanteToUpdate}
							handleClose={handleClose}
							setComprobantesListData={setComprobantesListData}
						/>
					}
				</MDBox>
			</Modal>
			{/* ToastContainer global en DashboardNavbar */}
		</DashboardLayout>
	);
}
const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	maxWidth: 1080,
};
export default Comprobantes;
